import React from 'react'
import _ from 'lodash'
import { format } from 'date-fns'

import { ellipsifyByWord } from '~/tools/strings/ellipsify'

import SharePopup from '~/views/Share/events'

class TrayItem extends React.Component {
  constructor(props) {
    super(props)

    this.handleShareToggleClick = this.handleShareToggleClick.bind(this)

    this.state = { hoverOverflow: false }
  }

  get metaData() {
    const gist = _.get(this.props, 'item.gist')
    const metaData = _.get(window.settings, 'brand.metadata')
    if (!gist || !metaData) return

    return(
      <div className="metadata">
        { (metaData.displayDuration && gist.readTime) &&
          <span>{ this.formatReadtime(gist.readTime) }</span>
        }
        { (metaData.displayAuthor && gist.author) &&
          <span>{ gist.author }</span>
        }
        { (metaData.displayPublishDate && gist.publishDate) &&
          <span>{ format(gist.publishDate, 'MMM D') }</span>
        }
      </div>
    )
  }

  //TEMP until backend fixes readTime string format
  formatReadtime(readTime) {
    const duration = readTime.split(' ')[0]
    return duration < 1 
      ? `${duration * 60}sec read`
      : `${duration}min read`
  }

  get thumbImage() {
    const images = this.props.item.gist.imageGist
    if (!images)
      return

    return(
      images._16x9 ||
      images._3x4 ||
      images._1x1 ||
      images._32x9 ||
      _.get(window.settings, 'images.placeholderCover')
    )
  }

  get backgroundThumb() {
    return {
      background: `url(${this.thumbImage}?impolicy=resize&w=500&h=280) no-repeat`,
      backgroundSize: 'contain',
      backgroundPosition: 'center',
    }
  }

  render() {
    var gist = this.props.item.gist
    
    return (
      <a
        className={ `article-tray-item ${ this.state.hoverOverflow ? 'overflow' : '' }` }
        href={gist.permalink}
        ref={ el => this.el = el  }>
        <div className="image-container" style={ this.backgroundThumb }>
          { this.metaData }
        </div>
        <div className="details">
          <div className="title-container">
            <div className="title">{ gist.title }</div>
            { this.props.sharing &&
              <div className="share">
                <div className="share-toggle__icon" onClick={ this.handleShareToggleClick }>
                  <span className="small-rect"></span>
                  <span className="small-rect"></span>
                  <span className="small-rect"></span>
                </div>
              </div>
            }
          </div>

          <div className="title-divider site-background-color"></div>
          {gist.summaryText && <div className="description">{ ellipsifyByWord(gist.summaryText, 15, 15) }</div>}
        </div>
      </a>
    )
  }

  handleShareToggleClick(event) {
    event.preventDefault()
    const shareOptions = {
      position: event.currentTarget.getBoundingClientRect(),
      data: this.props.item.gist,
      options: {
        watchlist: false
      }
    }
    SharePopup.open(shareOptions)
  }
}

export default TrayItem;
